import _ from './util';

export default function enableChangeHandling(reducer, handler) {
  return function changeHandlingReducer(prevState, action) {
    let currentState = reducer(prevState, action);
    let nextState;
    let count = 0;
    while (!_.isEqual(prevState, currentState)) {
      count++;
      nextState = handler(currentState, {
        value: currentState,
        prevValue: prevState,
        path: '',
        state: currentState,
        prevState
      });
      prevState = currentState;
      currentState = nextState;
    }
    return currentState;
  };
}
